module.exports = __webpack_public_path__ + "img/selected6-min.e35e769e.png";